export default __webpack_public_path__ + "static/classic-black-31700cab55139fffeaf589e24544110f.svg";